var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('fa-icon',{staticClass:"kai-checkbox cursor-pointer",class:{ checked: _vm.value, readonly: _vm.readonly, disabled: _vm.disabled },attrs:{"icon":"check-circle","size":"2x"},on:{"click":_vm.toggle}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }